import React, { useEffect, useState } from 'react'
import { GoogleMap, useLoadScript, Marker, InfoWindow } from '@react-google-maps/api'
import { TextFinder } from '../../../components/TextFinder'
import { CardEvent } from '../../../components/Events/CardEvent'
import { ArtistCard } from '../../../components/Events/ArtistCard'
import { eventService } from '../../../services/event.service'
import { useAuth } from '../../../hooks/useAuth'
import { NothingToShow } from '../../../components/Dashboard/NothingToShow'
import { CategoryIcon } from '../../../components/CategoryIcon' // Lo agregué
import { StateDropdown } from '../../../components/StateDropdown' // Lo agregué
import { DatePicker } from '../../../components/DatePicker' // Lo agregué
import { PricePicker } from '../../../components/PricePicker' // Lo agregué
import { Link } from 'react-router-dom'
import { artistService } from '../../../services/artist.service'
import './style.scss'

export const ExploreEvent = ({ isAdmin }) => {
  // Estados
  const [events, setEvents] = useState([])
  const [artists, setArtists] = useState([])
  const [isRejected, setIsRejected] = useState(false)
  const [categorySelected, setCategorySelected] = useState(null)
  const [categoryName, setCategoryName] = useState(null)
  const [stateSelected, setStateSelected] = useState(null) // Lo agregué
  const [DateSelected, setDateSelected] = useState(null)
  const [stateName, setStateName] = useState(null) // Lo agregué
  const [monthFromSelected, setMonthFromSelected] = useState(null) // Lo agregué
  const [PricetoFind, setPriceToFind] = useState(null)
  const [monthFromName, setMonthFromName] = useState(null) // Lo agregué
  const [monthToSelected, setMonthToSelected] = useState(null) // Lo agregué
  const [monthToName, setMonthToName] = useState(null) // Lo agregué
  const [textToFind, setTextToFind] = useState(null)

  // hooks
  const { user } = useAuth()
  // Efectos
  useEffect(() => {
    const getArtists = async () => {
      try {
        const dbArtists = await artistService.getAllArtists()
        setArtists(dbArtists)
      } catch (error) {
        console.log(error)
        setArtists(null)
      }
    }
    getArtists()
    const getEvents = async () => {
      const filterState = !parseInt(stateSelected) ? 0 : parseInt(stateSelected)
      const filterCategory = !categoryName ? 0 : categoryName
      const filterMonthFrom = (!monthFromSelected || (monthFromSelected.includes(' '))) ? 0 : monthFromSelected
      const filterMonthTo = (!monthToSelected || (monthToSelected.includes(' '))) ? 0 : monthToSelected
      const filterTextToFind = !textToFind ? 0 : textToFind
      try {
        const dbEvents = await eventService.getEventsByFilters(filterState, filterCategory, filterMonthFrom, filterMonthTo, filterTextToFind)
        setEvents(dbEvents)
      } catch (error) {
        console.log(error)
      }
    }
    events.length = 1 // Lo agregué para no mostrar la alerta al cargar
    getEvents()
  }, [stateSelected, monthFromSelected, monthToSelected, categorySelected, isRejected, textToFind, PricetoFind])
  const handlerOnSubmit = (event) => {
    event.target.preventDefault()
  }

  let notFoundMessage = ''
  if (!notFoundMessage) {
    notFoundMessage += textToFind || ''
    notFoundMessage += ' '
    notFoundMessage += categoryName || ''
    notFoundMessage += notFoundMessage ? (stateName !== null ? ` en ${stateName}` : '') : (stateName || '')
    if (monthFromSelected && monthToSelected && (monthFromSelected !== 'Invalid date') && (monthToSelected !== 'Invalid date')) {
      notFoundMessage += ` fecha:  ${monthFromSelected}`
    }
  }

  return (
    <>
        {/* Page content */}
        <section className="container mt-1 mb-lg-5 pt-lg-2 pb-5 event-discover white-text">
          <div className="row">
            <div className="justify-content-center inline-display px-4">
              <form className="row gy-2 d-flex justify-content" onSubmit={handlerOnSubmit}>
                <TextFinder setTextToFind={setTextToFind} />
                {/* <DatePicker setMonthFromSelected={setMonthFromSelected} setMonthFromName={setMonthFromName} setMonthToSelected={setMonthToSelected} setMonthToName={setMonthToName}/> */}
              </form>
            </div>
          </div>
          <div className="row pb-4 pt-4">
            <div className="pb-4 align-items-center d-flex">
              <div className="scroll mb-n4 mx-n2">
                <CategoryIcon categorySelected={categorySelected} setCategorySelected={setCategorySelected} setCategoryName={setCategoryName} />
              </div>
            </div>
          </div>
          <h2 className="mb-3 inline-display">
            Eventos
          </h2>
          <div className="row">
          {
            events.length === 0 && textToFind !== 0
              ? (
                <NothingToShow
                title='¡Oh no!'
                subtitle='Lo sentimos, al día de hoy no tenemos eventos que coincidan con la búsqueda:'
                message={notFoundMessage} // Esto falta evitar que se muestre al inicio
                />
                )
              : (
                  events.slice(0, 12).map((event, index) => (
                <div className="col-12 col-md-3"
                  key={index}
                >
                  <CardEvent
                    setIsRejected={setIsRejected}
                    isRejected={isRejected}
                    isAdmin={isAdmin}
                    {...event}
                  />
                </div>
                  ))
                )
            }
          </div>
        {/* Pagination */}
          <h2 className="pt-4 mb-2 mb-md-0">
            Artistas
          </h2>
          <h6 className="pb-4 pb-3 mb-2 mb-md-0">
            Descubre tu nuevo artista favorito.
          </h6>
          <div className="row d-flex flex-row flex-nowrap overflow-auto">
              {
                artists.slice(0, 6).map((artist, index) => (
                <div className="col-6 col-md-4 col-xl-2"
                key={index}
                >
                  <ArtistCard
                    setIsRejected={setIsRejected}
                    isRejected={isRejected}
                    isAdmin={isAdmin}
                    {...artist}
                  />
                </div>
                ))
              }
            </div>
        </section>
    </>
  )
}
